'use client';

import { useTranslations } from 'next-intl';
import { Button } from '~/components/Button';
import { Drawer } from '~/components/Drawer';
import { Link } from '~/components/Link';
import styles from './SaveButton.module.css';

interface SaveTripDialogProps {
  isLoggedIn: boolean;
  isOpen: boolean;
  onClose: () => void;
  onLogin: () => void;
  onGoToAccount: () => void;
}

export function SaveTripDialog({ isLoggedIn, isOpen, onClose, onLogin, onGoToAccount }: SaveTripDialogProps) {
  const t = useTranslations('account');

  return (
    <Drawer
      isOpen={isOpen}
      close={onClose}
      title={isLoggedIn ? t('saved_defer') : t('save_defer')}
      showAsDialogInDesktop
      maxWidth={520}
    >
      {isLoggedIn ? (
        <p>
          {t.rich('save_confirmed', {
            link: (chunks) => <Link href="/account">{chunks}</Link>
          })}
        </p>
      ) : (
        <p className={styles.dialogBody}>{t('login_prompt_save')}</p>
      )}
      <div className={styles.dialogFooter}>
        {isLoggedIn ? (
          <Button onPress={onGoToAccount} size="fullWidth">
            {t('account')}
          </Button>
        ) : (
          <>
            <Button onPress={onClose} size="fullWidth" variant="tertiary">
              {t('defer')}
            </Button>
            <Button onPress={onLogin} size="fullWidth">
              {t('log_in')}
            </Button>
          </>
        )}
      </div>
    </Drawer>
  );
}
